/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S4_Li4Inputs */

const en_guide_what_is_json_s4_li4 = /** @type {(inputs: Guide_What_Is_Json_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Data Exchange</strong>: Sharing structured data between different systems and programming languages`)
};

const ko_guide_what_is_json_s4_li4 = /** @type {(inputs: Guide_What_Is_Json_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>데이터 교환</strong>: 서로 다른 시스템과 프로그래밍 언어 간에 구조화된 데이터를 공유합니다`)
};

const ja_guide_what_is_json_s4_li4 = /** @type {(inputs: Guide_What_Is_Json_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>データ交換</strong>: 異なるシステムやプログラミング言語間で構造化データを共有します`)
};

/**
* | output |
* | --- |
* | "<strong>Data Exchange</strong>: Sharing structured data between different systems and programming languages" |
*
* @param {Guide_What_Is_Json_S4_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s4_li4 = /** @type {((inputs?: Guide_What_Is_Json_S4_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S4_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s4_li4(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s4_li4(inputs)
	return ja_guide_what_is_json_s4_li4(inputs)
});